import { GenericActions } from "../../redux/generic-actions";
import { componentsReducer } from "../../redux/root.reducer";

export function toggleFilterReducerFactory(rootProp, initialState) {
    return function toggleFilterReducer(state = initialState, action) {
        state = componentsReducer(rootProp, state, action);
        switch (action.type) {
            case `${rootProp}::${GenericActions.TOGGLE_SELECT}`:
                const index = action.payload;
                const filters = state.getIn([action.stateProp, "filters"])
                    .map((filter, i) => {
                        if (i !== index) {
                            return filter.set("state", false);
                        } else {
                            const currentState = filter.get("state");
                            return filter.set("state", !currentState);
                        }
                    });
                return state.setIn([action.stateProp, "filters"], filters);

            case `${rootProp}::${GenericActions.STATE_RESET}`:
                return initialState;
            default:
                return state;
        }
    };
}
